import { render } from "./InsuranceAccountsReceivable.vue?vue&type=template&id=484e75bb"
import script from "./InsuranceAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./InsuranceAccountsReceivable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__